export type ServiceSelectSource = {
  serviceId: number;
  name: string;
  tagNameLocalized?: string | null;
};

export type ServiceSelectItem = {
  key: string;
  label: string;
  sectionName?: string;
};

/**
 * Turns services into `LimeSelect` options grouped by their category,
 * preserving the incoming order within a category and pushing uncategorized
 * services to the end. Clients that categorize nothing get no sections at all,
 * so they don't end up with a single heading over the entire list.
 */
export function buildServiceSelectItems(
  services: ServiceSelectSource[],
  uncategorizedSectionName: string,
): ServiceSelectItem[] {
  const hasCategories = services.some((service) => !!service.tagNameLocalized);

  const toItem = (service: ServiceSelectSource): ServiceSelectItem => ({
    key: service.serviceId.toString(),
    label: service.name,
    sectionName: hasCategories
      ? (service.tagNameLocalized ?? "") || uncategorizedSectionName
      : undefined,
  });

  return [
    ...services.filter((service) => !!service.tagNameLocalized).map(toItem),
    ...services.filter((service) => !service.tagNameLocalized).map(toItem),
  ];
}
